import React from 'react'
import { ILLogoData } from 'src/assets/image'

function Kategori({ ...props }) {
    return (
        <div>
            <div className="widget widget-text">
                <h3 className="widget-title">Kategori</h3>
                <div className="ttm-author-widget">
                    <div className="author-widget_img">
                        <center>
                            <img className="author-img img-fluid" src={`${props.FileLogo}`} onError={(e) => { e.target.onerror = null; e.target.src = ILLogoData }} alt={props.Name} width="250px" />
                        </center>
                    </div>
                    <h6>{props.Name}</h6>
                    <p className="author-widget_text">
                        {props.Description}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Kategori
